<template>
  <b-modal
    id="modal-company"
    :ok-title="$t('Save')"
    :cancel-title="$t('Abort')"
    cancel-variant="outline-secondary"
    hideHeaderClose
    no-close-on-backdrop
    @ok.prevent="saveData"
    @cancel="resetModal"
    @hidden="modalHidden"
    size="lg"
    centered
  >
    <b-overlay :show="show" rounded="sm">
      <b-row>
        <b-col cols="12" class="modalTitle">
          <h2 class="font-weight-bolder" v-if="!editTitle">
            {{ pinpoint.label }}
            <b-button
              v-if="pinpoint.type.editable"
              class="btn-icon rounded-circle"
              variant="flat-primary"
            >
              <feather-icon
                icon="EditIcon"
                @click="editTitle = true"
                variant="flat-primary"
              />
            </b-button>
          </h2>
          <b-form-input
            v-if="editTitle"
            type="text"
            v-model="pinpoint.label"
            maxlength="25"
            autofocus
          />
          <span>{{ $t("pin_point.Info_company") }}</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            :label="$t('pin_point.link_text')"
            label-for="link_text"
          >
            <b-form-input
              id="link_text"
              :placeholder="$t('pin_point.link_text')"
              v-model="fields.link_text"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label-for="link_url" :label="$t('pin_point.link_url')">
            <div class="form-label-group">
              <b-form-input
                id="link_url"
                :placeholder="$t('pin_point.link_url')"
                v-model="fields.link_url"
              />
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            label-for="profile_url"
            :label="$t('pin_point.profile_url')"
          >
            <div class="form-label-group">
              <b-form-input
                id="profile_url"
                :placeholder="$t('pin_point.profile_url')"
                v-model="fields.profile_url"
              />
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            label-for="company_title"
            :label="$t('pin_point.company_title')"
          >
            <div class="form-label-group">
              <b-form-input
                id="company_title"
                :placeholder="$t('pin_point.company_title')"
                v-model="fields.title"
              />
            </div>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="$t('short_description')"
            label-for="description"
          >
            <b-form-textarea
              id="description"
              v-model="fields.description"
              :placeholder="$t('add_short_description')"
              rows="4"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="pin_hide">
          <icon-selector v-if="pinpoint.type.editable" v-model="icon">
          </icon-selector>
          <footer-pin-point v-model="hide_pinpont"></footer-pin-point>
        </b-col>
      </b-row>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BFormGroup,
  BForm,
  BButton,
  BModal,
  BFormFile,
  BOverlay,
  BFormInput,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import FooterPinPoint from "./footer";
import IconSelector from "./icon-selector";

import { updatePinpoint } from "@api/pinpoint";

export default {
  props: ["pinpoint"],
  name: "pin-point-company",
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormTextarea,
    BForm,
    BButton,
    BModal,
    BFormFile,
    BOverlay,
    FooterPinPoint,
    IconSelector,
    BFormInput,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      fields: { ...this.pinpoint.fields },
      hide_pinpont: !this.pinpoint.active,
      editTitle: false,
      icon: this.pinpoint.icon,
      show: false,
      maxChar: 350,
    };
  },
  methods: {
    saveData() {
      const $this = this;
      this.show = true;
      let formData = new FormData();
      formData.append("label", $this.pinpoint.label);
      formData.append("link_text", $this.fields.link_text);
      formData.append("link_url", $this.fields.link_url);
      formData.append("profile_url", $this.fields.profile_url);
      formData.append("title", $this.fields.title);
      formData.append("description", $this.fields.description);
      formData.append("icon", $this.icon);
      formData.append("active", $this.hide_pinpont ? 0 : 1);
      updatePinpoint($this.pinpoint.id, formData)
        .then((data) => {
          this.$emit("onSave");
          this.$bvModal.hide("modal-company");
          this.show = false;
        })
        .catch((error) => {
          console.log(error);
          this.show = false;
        });
    },
    resetModal() {
      this.fields = { ...this.pinpoint.fields };
      this.hide_pinpont = !this.pinpoint.active;
      this.icon = this.pinpoint.icon;
      this.$bvModal.hide("modal-company");
    },
    modalHidden() {
      this.editTitle = false;
    },
  },
};
</script>

<style></style>
